import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e9e5ce6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-coin-list",
  "aria-labelledby": "home-market-title"
};
const _hoisted_2 = {
  class: "market-shell"
};
const _hoisted_3 = {
  class: "market-board"
};
const _hoisted_4 = {
  class: "market-top"
};
const _hoisted_5 = {
  class: "market-heading"
};
const _hoisted_6 = {
  id: "home-market-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ".", -1));
const _hoisted_8 = {
  class: "market-actions"
};
const _hoisted_9 = ["aria-label"];
const _hoisted_10 = ["aria-pressed", "onClick"];
const _hoisted_11 = {
  key: 0,
  class: "market-grid"
};
const _hoisted_12 = ["aria-label", "onClick"];
const _hoisted_13 = {
  class: "asset-icon"
};
const _hoisted_14 = {
  class: "asset-initial"
};
const _hoisted_15 = ["src", "onError"];
const _hoisted_16 = {
  class: "asset-name"
};
const _hoisted_17 = {
  class: "asset-price"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "USDT", -1));
const _hoisted_19 = {
  key: 1,
  class: "market-empty",
  role: "status"
};
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import store from '@/store';
export default {
  __name: 'HomeMarketList',
  setup(__props) {
    const router = useRouter();
    const {
      t,
      locale
    } = useI18n();
    const activeTab = ref('popular');
    const failedIcons = ref(new Set());
    const tabs = computed(() => [{
      id: 'popular',
      label: t('homepage.market.tabs.popular')
    }, {
      id: 'gainers',
      label: t('homepage.market.tabs.gainers')
    }, {
      id: 'losers',
      label: t('homepage.market.tabs.losers')
    }]);
    const numberLocales = {
      ar: 'ar',
      de: 'de-DE',
      en: 'en-US',
      fr: 'fr-FR',
      hin: 'hi-IN',
      it: 'it-IT',
      jp: 'ja-JP',
      kr: 'ko-KR',
      nl: 'nl-NL',
      pt: 'pt-PT',
      ru: 'ru-RU',
      span: 'es-ES',
      tc: 'zh-TW',
      th: 'th-TH',
      tr: 'tr-TR'
    };
    const getNumberLocale = () => numberLocales[locale.value] || 'en-US';
    const availableKeys = computed(() => {
      const keys = store.state.marketCoin.length ? store.state.marketCoin : store.state.homeKey;
      return keys.filter(key => store.state.marketInfo[key]);
    });
    const marketCount = computed(() => availableKeys.value.length);
    const markets = computed(() => availableKeys.value.map(key => {
      const info = store.state.marketInfo[key];
      const quote = store.state.market[key] || {};
      return {
        key,
        name: info.name || info.stock || key,
        icon: info.icon,
        decimals: Number(info.decimal),
        price: Number(quote.last),
        change: Number(quote.growth)
      };
    }));
    const visibleMarkets = computed(() => {
      if (activeTab.value === 'popular') return markets.value.slice(0, 8);
      const pricedMarkets = markets.value.filter(item => Number.isFinite(item.price) && item.price > 0 && Number.isFinite(item.change));
      if (activeTab.value === 'gainers') {
        return pricedMarkets.filter(item => item.change > 0).sort((a, b) => b.change - a.change).slice(0, 8);
      }
      return pricedMarkets.filter(item => item.change < 0).sort((a, b) => a.change - b.change).slice(0, 8);
    });
    const formatPrice = item => {
      if (!Number.isFinite(item.price) || item.price <= 0) return '—';
      const decimals = Number.isFinite(item.decimals) ? Math.max(2, Math.min(item.decimals, 8)) : 6;
      const minimumFractionDigits = item.price >= 1 ? 2 : Math.min(decimals, item.price >= .01 ? 4 : 6);
      return new Intl.NumberFormat(getNumberLocale(), {
        minimumFractionDigits,
        maximumFractionDigits: decimals
      }).format(item.price);
    };
    const formatChange = item => {
      if (!Number.isFinite(item.price) || item.price <= 0 || !Number.isFinite(item.change)) return '—';
      const change = new Intl.NumberFormat(getNumberLocale(), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        signDisplay: item.change > 0 ? 'always' : 'auto'
      }).format(item.change);
      return `${change}%`;
    };
    const changeClass = item => ({
      rising: item.price > 0 && item.change > 0,
      falling: item.price > 0 && item.change < 0
    });
    const markIconFailed = key => {
      failedIcons.value = new Set([...failedIcons.value, key]);
    };
    const openMarket = key => {
      const name = store.state.marketContract.includes(key) && !store.state.marketCoin.includes(key) ? 'contract' : 'spotTrade';
      router.push({
        name,
        query: {
          key
        }
      });
    };
    const viewAllMarkets = () => router.push({
      name: 'spotTrade'
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, [_createTextVNode(_toDisplayString(_unref(t)('homepage.market.title')), 1), _hoisted_7]), _createElementVNode("p", null, _toDisplayString(_unref(t)('homepage.market.description')), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: "market-tabs",
        role: "group",
        "aria-label": _unref(t)('homepage.market.view')
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), tab => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.id,
          type: "button",
          class: _normalizeClass({
            active: activeTab.value === tab.id
          }),
          "aria-pressed": activeTab.value === tab.id,
          onClick: $event => activeTab.value = tab.id
        }, _toDisplayString(tab.label), 11, _hoisted_10);
      }), 128))], 8, _hoisted_9), _createElementVNode("button", {
        class: "market-all-link",
        type: "button",
        onClick: viewAllMarkets
      }, [_createTextVNode(_toDisplayString(_unref(t)('homepage.market.viewAll')) + " ", 1), _createVNode(_unref(ArrowRightOutlined), {
        "aria-hidden": "true"
      })])])]), _unref(visibleMarkets).length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleMarkets), item => {
        return _openBlock(), _createElementBlock("button", {
          key: item.key,
          class: "market-row",
          type: "button",
          "aria-label": _unref(t)('homepage.market.itemAria', {
            name: item.name,
            price: formatPrice(item),
            change: formatChange(item)
          }),
          onClick: $event => openMarket(item.key)
        }, [_createElementVNode("span", _hoisted_13, [_createElementVNode("span", _hoisted_14, _toDisplayString(item.name.slice(0, 1)), 1), item.icon && !failedIcons.value.has(item.key) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.icon,
          alt: "",
          onError: $event => markIconFailed(item.key)
        }, null, 40, _hoisted_15)) : _createCommentVNode("", true)]), _createElementVNode("strong", _hoisted_16, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_17, [_createElementVNode("strong", null, _toDisplayString(formatPrice(item)), 1), _hoisted_18]), _createElementVNode("span", {
          class: _normalizeClass(["asset-change", changeClass(item)])
        }, _toDisplayString(formatChange(item)), 3)], 8, _hoisted_12);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(marketCount) ? _unref(t)('homepage.market.noPriceChanges') : _unref(t)('homepage.market.dataPending')), 1))])])]);
    };
  }
};